export default {
  'component.tagSelect.expand': '展开',
  'component.tagSelect.collapse': '收起',
  'component.tagSelect.all': '全部',

  // 侧边栏折叠按钮
  'component.sider.collapse': '收起导航',

  // IconPicker 图标选择器
  'component.iconPicker.placeholder': '点击选择图标',
  'component.iconPicker.modalTitle': '选择图标',
  'component.iconPicker.searchPlaceholder': '搜索图标',

  // MultiTab 标签页右键菜单
  'component.multiTab.refresh': '重新加载',
  'component.multiTab.close': '关闭标签页',
  'component.multiTab.closeLeft': '关闭左侧标签页',
  'component.multiTab.closeRight': '关闭右侧标签页',
  'component.multiTab.closeOthers': '关闭其它标签页',
  'component.multiTab.closeAll': '关闭全部标签页',

  // 图片上传
  'component.iconUpload.upload':'上传',
  'component.iconUpload.uploadSucc':'上传成功',
  'component.iconUpload.uploadFail':'上传失败',

  // ProFormSelectWithAll
  'component.proFormSelectWithAll.selectAll': '全选',
  'component.proFormSelectWithAll.unselectAll': '取消全选',

};
